import { render } from "./TermAssurancePolicyDetails.vue?vue&type=template&id=f1e36f46&scoped=true"
import script from "./TermAssurancePolicyDetails.vue?vue&type=script&lang=js"
export * from "./TermAssurancePolicyDetails.vue?vue&type=script&lang=js"

import "./TermAssurancePolicyDetails.vue?vue&type=style&index=0&id=f1e36f46&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1e36f46"]])

export default __exports__